import type { ReactNode } from "react";
import { formatDateHeader, isToday } from "@/lib/dateUtils";
import { cn } from "@/lib/utils";

interface DateGroupProps {
  date: string;
  children: ReactNode;
}

export function DateGroup({ date, children }: DateGroupProps) {
  const today = isToday(date);

  return (
    <section className="animate-in fade-in slide-in-from-bottom-3 duration-500">
      {/* Date header */}
      <header className="mb-4">
        <h2
          className={cn(
            "text-sm font-semibold tracking-wide",
            today ? "text-primary" : "text-muted-foreground"
          )}
        >
          {formatDateHeader(date)}
          {today && <span className="ml-2 text-xs font-normal">(Today)</span>}
        </h2>
      </header>

      {/* Events */}
      {children}
    </section>
  );
}
